module.exports = __webpack_public_path__ + "img/upperabs-ecto-mesomorph-male.4ef114bc.svg";